let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("n3xnn")]).then(() => parcelRequire('bJeNZ'));